import React from 'react'
import styled from 'styled-components'

const StyledWrapper = styled.span`
  background-color: ${({ color }) => (color ? color : '#439b73')};
  border-radius: 18px;
  color: ${({ theme }) => theme.colors.white};
  display: block;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 1.78px;
  line-height: 1.5;
  margin: auto auto 10px;
  padding: 6px 10px;
  position: relative;
  text-align: center;
  text-transform: uppercase;

  ${({ theme }) => theme.media.tablet} {
    width: max-content;
  }

  ${({ theme }) => theme.media.desktop} {
    font-size: 12px;
    padding: 6px 30px;
    width: max-content;
  }

  ul {
    display: inline-block;
    text-decoration: underline;
  }

  a {
    display: inline-block;
    font-weight: 700;
    margin: 0px 3px;

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`

const Notice = ({ color, children }) => {
  return <StyledWrapper color={color}>{children}</StyledWrapper>
}

export default Notice
